import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type LocalCustomerManagementModuleSpecsFragment } from '../../../../api/fragments/LocalCustomerManagementModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import KYCFields from './KYCFields';
import KYCPresetsEmptyList from './KYCPresetsEmptyList';
import KYCPresetsTable from './KYCPresetsTable';
import { HeaderTabs } from './shared';

type LocalCustomerModuleInnerProps = {
    activeTab: HeaderTabs;
    module: LocalCustomerManagementModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const LocalCustomerModuleInner = ({ activeTab, module, permissions }: LocalCustomerModuleInnerProps) => {
    const { t } = useTranslation(['localCustomerModuleDetails']);

    switch (activeTab) {
        case HeaderTabs.KycPresets: {
            return (
                <>
                    <Divider>{t('localCustomerModuleDetails:dividers.kycPresets')}</Divider>
                    {module.kycPresets.length === 0 ? (
                        <KYCPresetsEmptyList module={module} permissions={permissions} />
                    ) : (
                        <KYCPresetsTable module={module} />
                    )}
                </>
            );
        }
        case HeaderTabs.KycFields: {
            return <KYCFields module={module} />;
        }

        default:
            return null;
    }
};

export default LocalCustomerModuleInner;
